import { render, staticRenderFns } from "./perfectlooper-play-icon.vue?vue&type=template&id=18d994be&"
import script from "./perfectlooper-play-icon.vue?vue&type=script&lang=js&"
export * from "./perfectlooper-play-icon.vue?vue&type=script&lang=js&"
import style0 from "./perfectlooper-play-icon.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports